import './aboutUs.scss';

(function () {
    console.log(111, 'aboutUs init');
})();
